//const short = require("short-uuid");
const baseModel = require("../baseModel")

/**
 * お知らせ有無フラグ用のデータ取得モデルクラス
 */
class NoticeStatusModel extends baseModel {
  /**
   * お知らせ有無フラグリストを取得する
   * @param {テナント(グループ)}} tenantId
   * @returns
   */
  static async getNoticeStatusList(userID, tenantId) {
    return await super.getList({ beginsWith: `noticestatus#${userID}` }, tenantId)
  }

  /**
   * お知らせ有無フラグを更新する
   * @param {*} data
   */
  static async updateNoticeStatus(data) {
    await super.updateData(data)
  }

}

module.exports = NoticeStatusModel;